import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager
} from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCMl1qovgWPt70Zrq4TEzmVwvOOwgo4DNg",
  authDomain: "matoshree-infra.firebaseapp.com",
  projectId: "matoshree-infra",
  storageBucket: "matoshree-infra.firebasestorage.app",
  messagingSenderId: "790055581707",
  appId: "1:790055581707:web:01fa1b87716b9654ec2f0e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Auth
export const auth = getAuth(app);

// Firestore with Offline Persistence
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});

// Storage
export const storage = getStorage(app);

export default app;